import React from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'

const TextBox = ({className, ...props} : React.HTMLProps<HTMLInputElement>) => 
    <div className={clsx(styles.container, className)}>
      <input type="text" className={styles.textbox} {...props} />
    </div>
  
  export default TextBox